import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import MaskedInput from "./MaskedInput";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Controller } from "react-hook-form";
var styles = {
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  margin: {
    margin: "0 10px"
  },
  textField: {// flexBasis: 200,
  },
  hidden: {
    width: 0,
    height: 0,
    display: "none"
  },
  truncate: {
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  hide: {
    display: "none"
  }
};

var TextFieldMaskHook =
/*#__PURE__*/
function (_Component) {
  _inherits(TextFieldMaskHook, _Component);

  function TextFieldMaskHook() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextFieldMaskHook);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextFieldMaskHook)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.reachedMax = (_this.props.value && _this.props.value.length) === _this.props.maxLength;

    _this.textMaskCustom = function (props) {
      var inputRef = props.inputRef,
          other = _objectWithoutProperties(props, ["inputRef"]);

      return React.createElement(MaskedInput, Object.assign({}, other, {
        getInputRef: inputRef,
        mask: _this.props.mask,
        defaultValue: other.value,
        type: "text"
      }));
    };

    return _this;
  }

  _createClass(TextFieldMaskHook, [{
    key: "getRenderedComponent",
    value: function getRenderedComponent() {
      return this.ref.current;
    }
  }, {
    key: "getClasses",
    value: function getClasses() {
      var classes = this.props.classes; // const statusClass = editStatus ? classes.edit : classes.disabled;
      // const hiddenClass = hidden ? classes.hidden : classes.none;

      if (this.props.showMargin === "none") {
        return "".concat(classes.textField, " ");
      } else {
        return "".concat(classes.textField, " ").concat(classes.margin, " ");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          input = _this$props.input,
          required = _this$props.required,
          meta = _this$props.meta,
          disabled = _this$props.disabled,
          className = _this$props.className,
          custom = _objectWithoutProperties(_this$props, ["input", "required", "meta", "disabled", "className"]); //let { submitFailed, error } = meta;


      var classes = this.props.classes; //let hasError = submitFailed && error;
      // if (!hasError && required && meta && meta.touched && input.value === "") {
      // 	hasError = true;
      // 	error = "* Required";
      // }

      var hasError = false;
      console.log(this.props);
      return React.createElement("div", {
        className: classes.root
      }, React.createElement(Controller, {
        as: React.createElement(TextField, {
          className: "".concat(className ? className : this.getClasses(), " ").concat(disabled ? classes.hide : ""),
          helperText: hasError ? error : " ",
          key: custom.key,
          required: required,
          validation: custom.validation,
          variant: custom.variant,
          label: custom.label,
          placeholder: custom.placeholder,
          onKeyUp: custom.onKeyUp,
          error: hasError //defaultValue={input.value}
          ,
          autoFocus: custom.autoFocus ? true : false,
          multiline: custom.multiLine ? true : false //id={input.name + "-input"}
          ,
          fullWidth: custom.fullWidth,
          margin: custom.margin,
          InputLabelProps: custom.InputLabelProps ? custom.InputLabelProps : {
            shrink: custom.labelShrink
          },
          InputProps: {
            inputComponent: this.textMaskCustom,
            disableUnderline: custom.disableUnderline ? true : false,
            maxLength: custom.maxLength,
            disabled: disabled
          }
        }),
        control: this.props.control,
        name: this.props.name
      }));
    }
  }]);

  return TextFieldMaskHook;
}(Component);

export default withStyles(styles)(TextFieldMaskHook);